module.exports = __webpack_public_path__ + "img/Valostoren_arvontakaruselliin_kuva.a74f8255.jpg";